// Structured office records for org_offices.

export interface OfficeInput {
  city: string;
  state: string | null;
  cbsa_code: string | null;
  cbsa_title: string | null;
}

/** Parse a legacy 'City, ST' mirror string into a structured office. */
export const parseOfficeString = (s: string): OfficeInput => {
  const [cityPart, statePart] = s.split(",");
  return {
    city: (cityPart ?? "").trim(),
    state: statePart && statePart.trim() !== "" ? statePart.trim() : null,
    cbsa_code: null,
    cbsa_title: null,
  };
};

/** Trim, drop blank-city rows, and dedupe on (city, state) case-insensitively (first wins). */
export const normalizeOffices = (offices: OfficeInput[]): OfficeInput[] => {
  const seen = new Set<string>();
  const out: OfficeInput[] = [];
  for (const o of offices) {
    const city = (o.city ?? "").trim();
    if (city === "") continue;
    const state = o.state && o.state.trim() !== "" ? o.state.trim() : null;
    const key = `${city.toLowerCase()}|${(state ?? "").toLowerCase()}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ city, state, cbsa_code: o.cbsa_code ?? null, cbsa_title: o.cbsa_title ?? null });
  }
  return out;
};

// Offices are written ONLY through save_org_profile_patch (p_offices), in the
// same transaction as the profile. That function takes the offices advisory
// lock and THEN the organizations row lock — the same order replace_org_offices
// takes when console-org-edit (service role) still calls it standalone — so the
// two writers cannot deadlock against each other.
